import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Card,
  MenuItem,
  Typography,
  Popover,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import HelpIcon from '@material-ui/icons/Help';
import { pathOr } from "ramda";
import ParticlesBg from 'particles-bg';
import Link from '@material-ui/core/Link';
import { updateBaseUrl } from "../../store/actions/config.actions";
import { api, auth } from "../../common/api-utils";
import SkeletonShell from '../../components/Skeleton';
import useStyles from "./styles";
import {
    reset,
    getMetaAssets,
  } from "../../store/actions/auth.actions";
const getFaviconEl = () => document.getElementById("favicon");


const ResetPassword = () => {
    const [username, setUsername] = useState("");
    const [newpassword, setNewpassword] = useState("");
    const [newconfirmpassword, setConfirmpassword] = useState("");
    const [errorshow ,setErrorShow] = useState({});
    const [url, setUrl] = useState("");
    const [logo, setLogo] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const classes = useStyles();
    const dispatch = useDispatch();
    useEffect(() => {
      const getUrl = async () => {
        try {
            setUrl(process.env.REACT_APP_BASE_URL);
        } catch (ex) {
          console.log(ex);
        }
      };
      getUrl();
    }, []);
    useEffect(() => {
        const getLogos = async () => {
          try {
            const validateLoginParams={params:{'authId': '','accessToken': ''},'verify_URL':process.env.REACT_APP_VERIFY_URL};
            dispatch(getMetaAssets(validateLoginParams)).then(function(res){
         
            // const res = await getMetaAssets();
            const faviconEl = getFaviconEl();
            if (pathOr(undefined, ["data", "logo_icon"], res)) {
              localStorage.setItem("favicon", res.data.logo_icon);
            }
            faviconEl.href = res.data.logo_icon;
            setLogo(res.data.logo_image);
          })
          } catch (ex) {
            console.log(ex);
          }
        };
        getLogos();
      }, []);
    const setBaseUrl = (e) => {
        dispatch(updateBaseUrl(e.target.value));
        auth.setBaseURL(e.target.value);
        api.setBaseURL(e.target.value);
        setUrl(e.target.value);
      };
    const onSubmit = async (e) => {
        e.preventDefault();
        const payload = {
          username,
          newpassword,
          newconfirmpassword,
          url
        };
        //console.log(payload);
        const isValid = formValidation(payload);
        console.log(isValid);
        setErrorShow(isValid.errors);
        if(isValid.formIsValid){
          dispatch(reset(payload));
        }
       //dispatch(reset(payload));
      };
    const formValidation = (payload) => {
        let requiredTxt = 'Missing Required Field:';
        let invalidTxt = 'Invalid Value: ';
        let errors = {};
        let formIsValid = true;
        if(payload['username'] && payload['username'].trim())
					{
						let passwordExp = /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/;
						if(!payload['newpassword'].trim())
						{
							formIsValid = false;
							errors['newpassword'] = requiredTxt+" New password";
						}
						if(!payload['newconfirmpassword'].trim())
						{
							formIsValid = false;
							errors['newconfirmpassword'] = requiredTxt+"Confirm new password";
						}

						if(payload['newpassword'].trim() !== payload['newconfirmpassword'].trim())
						{
							formIsValid = false;
							errors['newpassword'] = '*Confirm password is not matching.';
						}
						if (payload['newpassword'].trim() && !payload['newpassword'].trim().match(passwordExp)) {
							formIsValid = false;
							errors['newpassword'] = '*Please enter secure and strong password.';
						}

						if (payload['newconfirmpassword'].trim() && !payload['newconfirmpassword'].trim().match(passwordExp)) {
							formIsValid = false;
							errors['newconfirmpassword'] = '*Please enter secure and strong password.';
						}
					}
	        return { formIsValid: formIsValid, errors: errors };

      }
  return (
    <div className={classes.container}>
      <ParticlesBg type="cobweb" color="#b2dae8" bg={true}  rps='0.9' />
      <Card className={classes.card}>
        <div className={classes.formWrapper}>
          {logo ? (
             <img
             src={logo}
             alt="logo"
             style={{ margin: "5px 0", maxHeight:'100px' }}
           />
          ) : (
              <Typography
                variant="h6"
                weight="medium"
                className={classes.logotype}
              >
              

            {/*process.env.REACT_APP_BRAND_NAME*/}
              </Typography>
            )}
          <form onSubmit={onSubmit}>
         
          {logo ? 
          <>
           <h3 className={classes.titleforgot}>Reset Password</h3>
            <TextField
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              placeholder="Username"
              type="username"
              errors="errorrrjjj"
              className={classes.formField}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            />
            <span style={{color:"red"}}>{errorshow['username']}</span>
            {/*Object.keys(errorshow).map((key)=>{
              return <span style={{color:"red"}}>{errorshow['username']}</span>
            })*/}
            <TextField
              id="newpassword"
              value={newpassword}
              onChange={(e) => setNewpassword(e.target.value)}
              margin="normal"
              placeholder="New password"
              type="password"
              className={classes.formField}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            />
            {errorshow['newpassword'] ? <>
            <div className={classes.customRequire} style={{color:"red"}}>{errorshow['newpassword']} <HelpIcon onClick={handleClick}>
              Open Popover
            </HelpIcon></div> 
            
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Typography className={classes.typography}><div className={classes.cardadj}>Password must contain 8 character.<br /> Password must contain 1 small & capital alphabet.<br />Password must contain 1 special character.</div></Typography>
            </Popover> </>:""}
            <TextField
              id="confirmpassword"
              value={newconfirmpassword}
              onChange={(e) => setConfirmpassword(e.target.value)}
              margin="normal"
              placeholder="Confirm Password"
              type="password"
              className={classes.formField}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            />    
            <span style={{color:"red"}}>{errorshow['newconfirmpassword']}</span>        
            {/*Object.keys(errorshow).map((key)=>{
              return <span style={{color:"red"}}>{errorshow['newconfirmpassword']}</span>
            })*/}
            
              <Button
                type="submit"
                //onClick={onSubmit}
                variant="contained"
                color="primary"
                size="large"
                disabled={!username.length || !newpassword.length || !newconfirmpassword.length}
                className={classes.formField}
              >
                Reset
              </Button>  
              <Link href="/login" className={classes.fixedCenter}>
              Back to Login
                </Link>        
              </>:
               // Added By deep On 09-02-2020 for login page skeleton
              <SkeletonShell layout="login"/>
          }
          </form>
          
        </div>
      </Card>
    </div>
  );
};

export default ResetPassword;
